import { OptionsGroup, Option, cn } from "ui";
import { useField } from "../hooks/useField";
import { useFormFieldContext } from "./FormField";

interface OptionsFormFieldProps {
  /**
   * [Value, Label][]
   */
  options: [string, string][];
  optionClassName?: string;
  className?: string;
}

export function OptionsFormField({
  options,
  optionClassName,
  className,
}: OptionsFormFieldProps) {
  const {
    name,
    disabled,
    readOnly,
    required,
    defaultValue = "",
    validation,
    customValidation,
    descriptionId,
    errorMessageId,
    shouldUnregister,
  } = useFormFieldContext();

  const { ref, value, onChange, onBlur, error } = useField({
    name,
    defaultValue,
    validation,
    customValidation,
    shouldUnregister,
  });

  return (
    <OptionsGroup
      ref={ref}
      value={value}
      onValueChange={onChange}
      disabled={disabled || readOnly}
      error={!!error}
      aria-required={required}
      aria-describedby={
        !error ? `${descriptionId}` : `${descriptionId} ${errorMessageId}`
      }
      aria-invalid={!!error}
      className={className}
    >
      {options.map(([optionValue, optionLabel]) => (
        <Option
          key={optionValue}
          value={optionValue}
          onBlur={onBlur}
          className={cn("text-xs", optionClassName)}
        >
          {optionLabel}
        </Option>
      ))}
    </OptionsGroup>
  );
}
